import {
    AppliedPromocodeDTO,
    ApplyPromocodeModel,
    BalanceIncreaseListApiV1BillingBalanceIncreaseGetParams,
    BalanceIncreaseOutputDTO,
    DepositCreateOutputDTO,
    RecurringPaymentDetailOutputDTO,
    ServiceChargeListApiV1BillingServiceChargeGetParams,
    ServiceChargeOutputDTO,
    StorageTariffGetList,
    StorageTariffUser,
    StorageTariffUserGetListActiveForUser,
    StorageTariffUserInputCreate,
    WIDepositCreateModel,
} from '../swagger/dto'
import { deleteRequest, getRequest, patchRequest, postRequest } from './config'
import {
    BILLING_ADDED_URL,
    BILLING_SPENT_URL,
    DEPOSIT_URL,
    PROMOCODE_URL,
    RECURRING_PAYMENT_URL,
    STORAGE_TARIFF_USER_URL,
    STORAGE_TARIFFS_URL,
} from './endpoints.constants'

export const applyPromocode = async (data: ApplyPromocodeModel) => {
    const response = await postRequest<ApplyPromocodeModel, AppliedPromocodeDTO>(
        PROMOCODE_URL,
        data,
    )
    return response.data
}

export const deposit = async (data: WIDepositCreateModel) => {
    const response = await postRequest<WIDepositCreateModel, DepositCreateOutputDTO>(
        DEPOSIT_URL,
        data,
    )
    return response.data
}

export const recurringPayment = async () => {
    const response = await getRequest<RecurringPaymentDetailOutputDTO>(RECURRING_PAYMENT_URL)
    return response.data
}

export const createRecurringPayment = async (payload) => {
    const response = await postRequest<RecurringPaymentDetailOutputDTO>(
        RECURRING_PAYMENT_URL,
        payload,
    )
    return response.data
}

export const changeRecurringPayment = async (payload) => {
    const response = await patchRequest<RecurringPaymentDetailOutputDTO>(
        RECURRING_PAYMENT_URL,
        payload,
    )
    return response.data
}

export const billingAdded = async (
    params?: BalanceIncreaseListApiV1BillingBalanceIncreaseGetParams,
) => {
    const response = await getRequest<BalanceIncreaseOutputDTO>(BILLING_ADDED_URL, params)
    return response.data
}

export const billingSpent = async (
    params?: ServiceChargeListApiV1BillingServiceChargeGetParams,
) => {
    const response = await getRequest<ServiceChargeOutputDTO>(BILLING_SPENT_URL, params)
    return response.data
}

export const storageTariffs = async () => {
    const response = await getRequest<StorageTariffGetList>(STORAGE_TARIFFS_URL)
    return response.data
}

export const storageTariffUser = async () => {
    const response = await getRequest<StorageTariffUserGetListActiveForUser>(
        `${STORAGE_TARIFF_USER_URL}`,
    )
    return response.data
}

export const createStorageTariffUser = async (payload) => {
    const response = await postRequest<StorageTariffUserInputCreate>(
        STORAGE_TARIFF_USER_URL,
        payload,
    )
    return response.data
}

export const removeStorageTariffUser = async (params) => {
    const response = await deleteRequest<StorageTariffUser>(
        `${STORAGE_TARIFF_USER_URL}/${params.id}`,
    )
    return response.data
}
